module.exports = __webpack_public_path__ + "img/xbn.661e0818.jpg";